export const tests = [
  {
    id: 1,
    title: "Name Enquiry",
    type: "name-enquiry",
    subtitle: "Run tests, requests and responses, make API Calls and perform other related activities.",
    steps: [
      {
        id: 1,
        name: "Confirm the requests matches expected according to technical specifications",
        logs: {
          request: "<?xml version=“1.0” encoding=“UTF-8” ?> <NESingleRequest> <SessionID>000001100913103301000000000001<SessionID> <DestinationInstitutionCode>000002</DestinationInstitutionCode> <ChannelCode>1</ChannelCode> <AccountNumber>2222000000012345</AccountNumber> </NESingleRequest>",
          response: "<?xml version=“1.0” encoding=“UTF-8” ?> <NESingleResponse> <SessionID>000001100913103301000000000001<SessionID> <DestinationInstitutionCode>000002</DestinationInstitutionCode> <ChannelCode>1</ChannelCode> <AccountNumber>2222000000012345</AccountNumber> <AccountName>Ajibade Oluwasegun<AccountName> <BankVerificationNumber>1033000441</BankVerificationNumber> <KYCLevel>1</KYCLevel> <ResponseCode>00</ResponseCode> </NESingleResponse>",
        },
      },
    ],
  },
  {
    id: 2,
    title: "Fund Transfer",
    type: "funds-transfer",
    subtitle: "Run tests, requests and responses, make API Calls and perform other related activities.",
    steps: [
      {
        id: 2,
        name: "Confirm the requests matches expected according to technical specifications",
        logs: {
          request: "<?xml version=“1.0” encoding=“UTF-8” ?> <NESingleRequest> <SessionID>000001100913103301000000000001<SessionID> <DestinationInstitutionCode>000002</DestinationInstitutionCode> <ChannelCode>1</ChannelCode> <AccountNumber>2222000000012345</AccountNumber> </NESingleRequest>",
          response: "<?xml version=“1.0” encoding=“UTF-8” ?> <NESingleResponse> <SessionID>000001100913103301000000000001<SessionID> <DestinationInstitutionCode>000002</DestinationInstitutionCode> <ChannelCode>1</ChannelCode> <AccountNumber>2222000000012345</AccountNumber> <AccountName>Ajibade Oluwasegun<AccountName> <BankVerificationNumber>1033000441</BankVerificationNumber> <KYCLevel>1</KYCLevel> <ResponseCode>00</ResponseCode> </NESingleResponse>",
        },
      },
    ],
  },
  {
    id: 3,
    title: "Transaction Status Query",
    type: "transfer-status-query",
    subtitle: "Run tests, requests and responses, make API Calls and perform other related activities.",
    steps: [
      {
        id: 3,
        name: "Confirm the requests matches expected according to technical specifications",
        logs: {
          request: "<?xml version=“1.0” encoding=“UTF-8” ?> <NESingleRequest> <SessionID>000001100913103301000000000001<SessionID> <DestinationInstitutionCode>000002</DestinationInstitutionCode> <ChannelCode>1</ChannelCode> <AccountNumber>2222000000012345</AccountNumber> </NESingleRequest>",
          response: "<?xml version=“1.0” encoding=“UTF-8” ?> <NESingleResponse> <SessionID>000001100913103301000000000001<SessionID> <DestinationInstitutionCode>000002</DestinationInstitutionCode> <ChannelCode>1</ChannelCode> <AccountNumber>2222000000012345</AccountNumber> <AccountName>Ajibade Oluwasegun<AccountName> <BankVerificationNumber>1033000441</BankVerificationNumber> <KYCLevel>1</KYCLevel> <ResponseCode>00</ResponseCode> </NESingleResponse>",
        },
      },
    ],
  },
];
